import { render, staticRenderFns } from "./CustomImagePicker.vue?vue&type=template&id=534d8415&scoped=true"
import script from "./CustomImagePicker.vue?vue&type=script&lang=js"
export * from "./CustomImagePicker.vue?vue&type=script&lang=js"
import style0 from "./CustomImagePicker.vue?vue&type=style&index=0&id=534d8415&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534d8415",
  null
  
)

export default component.exports